import './style.css';
import React from 'react';
import MuiFormBuilder from '@rjsf/mui';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import validator from '@rjsf/validator-ajv6';
import CircularProgress from '@mui/material/CircularProgress';

import { LocationField, PlaqueField, TimeField, DateField } from './CustomFields';
import { TimeWidget, DateWidget, DateTimeWidget } from './CustomWidgets';
import { BaseInputTemplate, ObjectFieldTemplate, WrapIfAdditionalTemplate } from './CustomTemplates';

import { transformErrors } from './utils';
import { removeNulls } from 'helpers/formatObject';

const MuiForm = ({
  id,
  onError,
  onSubmit,
  onChange,
  formData,
  children,
  schema = {},
  uiSchema = {},
  customValidate,
  submit = 'ذخیره',
  loading = false,
  disabled = false,
  showSubmit = true,
  liveValidate = true,
  showErrorList = false,
}) => {
  return (
    <MuiFormBuilder
      id={id}
      noHtml5Validate
      focusOnFirstError
      schema={schema}
      onError={onError}
      onChange={onChange}
      onSubmit={onSubmit}
      uiSchema={uiSchema}
      validator={validator}
      liveValidate={liveValidate}
      showErrorList={showErrorList}
      customValidate={customValidate}
      transformErrors={transformErrors}
      formData={removeNulls(formData)}
      widgets={{ DateWidget, TimeWidget, DateTimeWidget }}
      fields={{
        location: LocationField,
        plaque: PlaqueField,
        time: TimeField,
        date: DateField,
      }}
      templates={{
        BaseInputTemplate,
        ObjectFieldTemplate,
        WrapIfAdditionalTemplate,
      }}
    >
      {
        <Stack columnGap={1} direction="row" alignItems="center" justifyContent="flex-end">
          {children}
          {showSubmit && (
            <Button
              size="medium"
              type="submit"
              color="primary"
              variant="contained"
              sx={{ minWidth: 120 }}
              disabled={loading || disabled}
            >
              {loading ? <CircularProgress size={24} color="secondary" /> : submit}
            </Button>
          )}
        </Stack>
      }
    </MuiFormBuilder>
  );
};

export default MuiForm;
